import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AdminMultimediaGalleriaService } from '../../services/admin-multimedia-galleria.service';
import { Multimedia } from '../../../shared/models/multimedia';
import { GalleriaModule } from 'primeng/galleria';
import {
  ImageThumbnailComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Guid } from '@web/utils';
import { Observable } from 'rxjs';
import { AdminMultimediaDetails } from '../../models/admin-multimedia-details';

@Component({
  selector: 'app-multimedia-fullscreen-galleria',
  imports: [
    CommonModule,
    GalleriaModule,
    SpinnerFilledComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
  ],
  templateUrl: './multimedia-fullscreen-galleria.component.html',
  styleUrl: './multimedia-fullscreen-galleria.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaFullscreenGalleriaComponent implements OnInit {
  private readonly multimediaGalleria = inject(AdminMultimediaGalleriaService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  /* prettier-ignore */
  public readonly fetchMultimediaDetailsFn = input.required<(id: Guid) => Observable<AdminMultimediaDetails>>();

  protected readonly files = signal<Multimedia[]>([]);

  protected displayFullScreenGalleria = false;
  protected activeIndex = 0;

  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.listenToFullscreenGalleriaShow();
  }

  protected fetchMultimediaDetails(
    id: Guid,
  ): Observable<AdminMultimediaDetails> {
    const fn = this.fetchMultimediaDetailsFn();

    return fn(id);
  }

  private listenToFullscreenGalleriaShow(): void {
    this.multimediaGalleria.show$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((galleria) => {
        this.files.set(galleria.images);
        this.activeIndex = galleria.activeIndex;
        this.displayFullScreenGalleria = true;
        this.changeDetectorRef.detectChanges();
      });
  }
}
